import { createHpApp } from '../shared_config';
import UserReportsModal from '@/views/user_reports/_modal';
import AdminAnnouncementModal from '@/views/admin/announcement/_modal';
import AnnouncementNotification from '@/views/admin/announcement/_announcement_notification';
import HotelSearchForm from '@/views/header/_hotel_search_form';
import LocaleSwitcher from '@/views/locale_switcher';

window.UserReportsModalApp = createHpApp({ components: { UserReportsModal } });
window.AdminAnnouncementModalApp = createHpApp({ components: { AdminAnnouncementModal } });

window.HeaderApp = createHpApp({
  components: {
    HotelSearchForm,
    LocaleSwitcher,
    AnnouncementNotification,
  },
});
window.HeaderApp.mount('#header-app');
